<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/Report/TransferBarcodeSupplier'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>คลังสินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reTbsOriginPlantCode'"
                    :name="'reTbsOriginPlantCode'"
                    :select2-options="reTbsOriginPlantCodeOptions"
                    multiple
                    v-model="reTbsOriginPlantCode"
                  ></select2> -->
                  <treeselect
                    v-model="reTbsOriginPlantCode"
                    :multiple="true"
                    :options="reTbsOriginPlantCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>Supplier:</label>

                  <treeselect
                    v-model="reTbsDestinationVendorId"
                    :multiple="true"
                    :load-options="LoadreTbsDestinationVendorIdOptions"
                    :async="true"
                    v-on:open="reLoadreTbsDestinationVendorIdOptions"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="false"
                    ref="reTbsDestinationVendorId"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>เลขที่เอกสารส่งซ่อม Supplier:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reTbsTransferJobNumber'"
                    :name="'reTbsTransferJobNumber'"
                    :select2-options="reTbsTransferJobNumberOptions"
                    multiple
                    v-model="reTbsTransferJobNumber"
                  ></select2> -->

                  <treeselect
                    v-model="reTbsTransferJobNumber"
                    :multiple="true"
                    :load-options="LoadreTbsTransferJobNumberOptions"
                    :async="true"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="false"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>เลขที่เอกสารรับคืนจาก Supplier:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reTbsReturnJobNumber'"
                    :name="'reTbsReturnJobNumber'"
                    :select2-options="reTbsReturnJobNumberOptions"
                    multiple
                    v-model=""
                  ></select2> -->
                  <treeselect
                    v-model="reTbsReturnJobNumber"
                    :multiple="true"
                    :load-options="LoadreTbsReturnJobNumberOptions"
                    :async="true"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="false"
                  />
                </div>
              </div>

              <!--Begin : Collap ค้นหาสินค้า-->
              <div class="col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12">
                <Collapsible class="product-collapsible">
                  <div slot="trigger">
                    <div class="customTrigger">
                      <div class="kt-portlet__head-label">
                        <h5 class="kt-portlet__head-title text-primary">
                          <i class="la la-minus-square"></i> ค้นหาสินค้า
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div slot="closedTrigger">
                    <div class="customTrigger">
                      <div class="kt-portlet__head-label">
                        <h5 class="kt-portlet__head-title text-primary">
                          <i class="la la-plus-square"></i> ค้นหาสินค้า
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div id="product">
                      <div class="row">
                          <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                              <div class="form-group">
                                  <label>BARCODE:</label>
                                  <input v-model="reTbsBarcode"
                                         type="text"
                                         class="form-control"
                                         placeholder="กรุณาระบุรหัส BARCODE (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)" />
                              </div>
                          </div>

                          <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                              <div class="form-group">
                                  <label>รหัสทรัพย์สิน(เบียร์สด):</label>
                                  <!-- <select2
              :css-style="'width: 100%;'"
              :css-class="'form-control m-select2'"
              :id="'reTbsDepartmentMaterialCode'"
              :name="'reTbsDepartmentMaterialCode'"
              :select2-options="
                reTbsDepartmentMaterialCodeOptions
              "
              multiple
              v-model="reTbsDepartmentMaterialCode"
            ></select2> -->

                                  <treeselect v-model="reTbsDepartmentMaterialCode"
                                              :multiple="true"
                                              :load-options="LoadreTbsDepartmentMaterialCodeOptions"
                                              :async="true"
                                              v-on:select="ClearAfterselect"
                                              searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                                              placeholder="กรุณาเลือก"
                                              :cacheOptions="false" />
                              </div>
                          </div>

                          <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                              <div class="form-group">
                                  <label>หมวดหมู่สินค้า:</label>
                                  <!-- <select2
              :css-style="'width: 100%;'"
              :css-class="'form-control m-select2'"
              :id="'reTbsProductGroupId'"
              :name="'reTbsProductGroupId'"
              :select2-options="reTbsProductGroupIdOptions"
              multiple
              v-model="reTbsProductGroupId"
            ></select2> -->
                                  <treeselect v-model="reTbsProductGroupId"
                                              :multiple="true"
                                              :options="reTbsProductGroupIdOptions"
                                              :clear-on-select="true"
                                              placeholder="กรุณาเลือก" />
                              </div>
                          </div>

                          <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                              <div class="form-group">
                                  <label>ประเภทสินค้า:</label>
                                  <!-- <select2
              :css-style="'width: 100%;'"
              :css-class="'form-control m-select2'"
              :id="'reTbsProductTypeId'"
              :name="'reTbsProductTypeId'"
              :select2-options="reTbsProductTypeIdOptions"
              multiple
              v-model="reTbsProductTypeId"
            ></select2> -->
                                  <treeselect v-model="reTbsProductTypeId"
                                              :multiple="true"
                                              :options="reTbsProductTypeIdOptions"
                                              :clear-on-select="true"
                                              placeholder="กรุณาเลือก" />
                              </div>
                          </div>

                          <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                              <div class="form-group">
                                  <label>สินค้า:</label>
                                  <!-- <select2
              :css-style="'width: 100%;'"
              :css-class="'form-control m-select2'"
              :id="'reTbsAssetCode'"
              :name="'reTbsAssetCode'"
              :select2-options="reTbsAssetCodeOptions"
              multiple
              v-model="reTbsAssetCode"
            ></select2> -->
                                  <treeselect v-model="reTbsAssetCode"
                                              :multiple="true"
                                              :options="reTbsAssetCodeOptions"
                                              :clear-on-select="true"
                                              placeholder="กรุณาเลือก" />
                              </div>
                          </div>

                          <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                              <div class="form-group">
                                  <label>แบรนด์สินค้า:</label>
                                  <!-- <select2
                                    :css-style="'width: 100%;'"
                                    :css-class="'form-control m-select2'"
                                    :id="'reTbsBrandId'"
                                    :name="'reTbsBrandId'"
                                    :select2-options="reTbsBrandIdOptions"
                                    multiple
                                    v-model="reTbsBrandId"
                                  ></select2> -->
                                  <treeselect v-model="reTbsBrandId"
                                              :multiple="true"
                                              :options="reTbsBrandIdOptions"
                                              :clear-on-select="true"
                                              placeholder="กรุณาเลือก" />
                              </div>
                          </div>
                          <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                              <div class="form-group">
                                  <label>รายการอะไหล่ที่ใช้:</label>
                                  <treeselect v-model="reTbsSupplierSpareId"
                                              :multiple="true"
                                              :options="supplierSpareOptions"
                                              :clear-on-select="true"
                                              placeholder="กรุณาเลือก" />
                              </div>
                          </div>
                          <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                              <div class="form-group">
                                  <label>สถานะระบุอะไหล่:</label>
                                  <treeselect v-model="reTbsSpareUsedStatusId"
                                              :multiple="true"
                                              :options="spareUsedStatusOptions"
                                              :clear-on-select="true"
                                              placeholder="กรุณาเลือก" />
                              </div>
                          </div>
                      </div>
                  </div>
                </Collapsible>
              </div>
              <!--End : Collap ค้นหาสินค้า-->

              <!--Begin : Collap ค้นหาข้อมูลส่ง-คืน-->
              <div
                v-if="this.$root.canShow([
                   'AGENT_REPORT',
                   'SUB_AGENT_REPORT',
                   'BR_REPORT',
                   'OFFICER_QIMAINTAIN',
                   'OFFICER_PLANT_QIMAINTAIN', 
                   'LEAD_QIMAINTAIN'
                   ])"
                class="col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12"
              >
                <Collapsible class="product-collapsible">
                  <div slot="trigger">
                    <div class="customTrigger">
                      <div class="kt-portlet__head-label">
                        <h5 class="kt-portlet__head-title text-primary">
                          <i class="la la-minus-square"></i> ค้นหาข้อมูลส่ง-คืน
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div slot="closedTrigger">
                    <div class="customTrigger">
                      <div class="kt-portlet__head-label">
                        <h5 class="kt-portlet__head-title text-primary">
                          <i class="la	la-plus-square"></i> ค้นหาข้อมูลส่ง-คืน
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div id="product">
                    <div class="row">
                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>จำนวนวันคงค้าง(เริ่มต้น):</label>
                          <input
                            v-model="reTbsOccupiedDaysStart"
                            type="number"
                            class="form-control"
                            placeholder="กรุณาระบุจำนวนวันคงค้าง(เริ่มต้น)"
                          />
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>จำนวนวันคงค้าง(สิ้นสุด):</label>
                          <input
                            v-model="reTbsOccupiedDaysEnd"
                            type="number"
                            class="form-control"
                            placeholder="กรุณาระบุจำนวนวันคงค้าง(สิ้นสุด)"
                          />
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group ">
                          <label class="label">วันที่ส่งซ่อม(เริ่มต้น):</label>
                          <div class="input-group date">
                            <input
                              readonly
                              type="text"
                              class="form-control"
                              placeholder="(วว/ดด/ปปปป)"
                              id="reTbsTransactionDateStart"
                              name="reTbsTransactionDateStart"
                              ref="reTbsTransactionDateStart"
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <i class="la la-calendar-check-o"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group ">
                          <label class="label">วันที่ส่งซ่อม(สิ้นสุด):</label>
                          <div class="input-group date">
                            <input
                              readonly
                              type="text"
                              class="form-control"
                              placeholder="(วว/ดด/ปปปป)"
                              id="reTbsTransactionDateEnd"
                              name="reTbsTransactionDateEnd"
                              ref="reTbsTransactionDateEnd"
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <i class="la la-calendar-check-o"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group ">
                          <label class="label"
                            >วันที่รับคืนจากการซ่อม(เริ่มต้น):</label
                          >
                          <div class="input-group date">
                            <input
                              readonly
                              type="text"
                              class="form-control"
                              placeholder="(วว/ดด/ปปปป)"
                              id="reTbsReturnTransactionDateStart"
                              name="reTbsReturnTransactionDateStart"
                              ref="reTbsReturnTransactionDateStart"
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <i class="la la-calendar-check-o"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group ">
                          <label class="label"
                            >วันที่รับคืนจากการซ่อม(สิ้นสุด):</label
                          >
                          <div class="input-group date">
                            <input
                              readonly
                              type="text"
                              class="form-control"
                              placeholder="(วว/ดด/ปปปป)"
                              id="reTbsReturnTransactionDateEnd"
                              name="reTbsReturnTransactionDateEnd"
                              ref="reTbsReturnTransactionDateEnd"
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <i class="la la-calendar-check-o"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>สถานะ:</label>
                          <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'reTbsReturnStatus'"
                            :name="'reTbsReturnStatus'"
                            :select2-options="reTbsReturnStatusOptions"
                            v-model="reTbsReturnStatus"
                          ></select2>
                        </div>
                      </div>
                    </div>
                  </div>
                </Collapsible>
              </div>
              <!--End : Collap ค้นหาผู้ถือครอง-->
            </div>

            <div class="row mb-3">
              <div
                class="col-xl-6"
                v-if="
                  this.$root.canShow([
                   'AGENT_REPORT',
                   'SUB_AGENT_REPORT',
                   'BR_REPORT',
                   'OFFICER_QIMAINTAIN',
                   'OFFICER_PLANT_QIMAINTAIN', 
                   'LEAD_QIMAINTAIN'
                  ])
                "
              >
                <button
                  class="btn btn-outline-primary"
                  @click="exportBarcodes"
                  type="submit"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
//import "vue-collapsible-component/lib/vue-collapsible.css";
import Collapsible from "../../Shared/Collapsible"; //"vue-collapsible-component";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";

// require("datatables.net-autofill-bs4");
// require("datatables.net-bs4");
// require("datatables.net-buttons-bs4");
// require("datatables.net-colreorder-bs4");
// require("datatables.net-fixedcolumns-bs4");
// require("datatables.net-fixedheader-bs4");
// require("datatables.net-keytable-bs4");
// require("datatables.net-responsive-bs4");
// require("datatables.net-rowgroup-bs4");
// require("datatables.net-rowreorder-bs4");
// require("datatables.net-scroller-bs4");
// require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
    Collapsible,
    Treeselect,
  },
  data: function() {
    var self = this;
    const today = moment();
    //const lastYear = moment().subtract(1, 'year');
    const lastYear = moment().startOf('year'); // ต้นปี

    return {
      reTbsReturnStatus: null,
      reTbsBarcode: null,
      reTbsDepartmentMaterialCode: [],
      reTbsOriginPlantCode: [],
      reTbsProductTypeId: [],
      reTbsBrandId: [],
      reTbsSupplierSpareId: [],
      reTbsSpareUsedStatusId: [],
      reTbsAssetCode: [],
      reTbsReturnJobNumber: [],
      reBCurrentLocationShop: [],
      reTbsDestinationVendorId: [],
      reTbsTransferJobNumber: [],
      reTbsProductGroupId: [],

      reTbsOccupiedDaysStart: null,
      reTbsOccupiedDaysEnd: null,

        reTbsTransactionDateStart: lastYear,
        reTbsTransactionDateEnd: today,
      reTbsReturnTransactionDateStart: null,
      reTbsReturnTransactionDateEnd: null,

      reTbsReturnStatusOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกสถานะ",
        allowClear: true,
        data: [
          { id: "ยังไม่ได้ส่งคืน", text: "ยังไม่ได้ส่งคืน", data: null },
          { id: "ส่งคืนแล้ว", text: "ส่งคืนแล้ว", data: null },
        ],
      },
      reBBarcodeOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกBarcode",
        allowClear: true,
        ajax: {
          url: "/Api/Barcode/Select2BarcodeAll",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reTbsDepartmentMaterialCodeOptions: [],
      // reTbsDepartmentMaterialCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกรหัสสินทรัพย์เบียร์สด",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Barcode/Select2DepartmentMaterial",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbsOriginPlantCodeOptions: [],
      // reTbsOriginPlantCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกคลังสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Plant/PlantOptions",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbsProductTypeIdOptions: [],
      // reTbsProductTypeIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbsBrandIdOptions: [],
      // reTbsBrandIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกแบรนด์สินค้า",
      //   ajax: {
      //     url: "/Api/ProductBrand/Select2SearchBrandExistProduct",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbsAssetCodeOptions: [],
      // reTbsAssetCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbsReturnJobNumberOptions: [],
      // reTbsReturnJobNumberOptions: {
      //   placeholder: "กรุณาเลือกเลขที่เอกสารรับคืนจาก Supplier",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2ReturnJobNumber",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBCurrentLocationShopOptions: {
        placeholder: "กรุณาเลือกผู้ถือครอง(ร้านค้า)",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/Select2ShopByAgent",
          data: function(params) {
            var query = {
              agentCode: null,
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reTbsDestinationVendorIdOptions: [],
      // reTbsDestinationVendorIdOptions: {
      //   placeholder: "กรุณาเลือก Supplier",
      //   multipla: true,
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Vendors/Select2Vendor",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbsTransferJobNumberOptions: [],
      // reTbsTransferJobNumberOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกเลขที่เอกสารส่งซ่อม Supplier",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2TransferJobNumber",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbsProductGroupIdOptions: [],
      // reTbsProductGroupIdOptions: {
      //   placeholder: "กรุณาเลือกหมวดหมู่สินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductGroup/Select2ProductGroup",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
        // },
        supplierSpareOptions: [],
        spareUsedStatusOptions: [],
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;

      self.reTbsReturnStatus = null;
      self.reTbsBarcode = null;
      self.reTbsDepartmentMaterialCode = [];
      self.reTbsOriginPlantCode = [];
      self.reTbsProductTypeId = [];
      self.reTbsBrandId = [];
      self.reTbsSupplierSpareId = [];
      self.reTbsSpareUsedStatusId = [];
      self.reTbsAssetCode = [];
      self.reTbsReturnJobNumber = [];
      self.reBCurrentLocationShop = [];
      self.reTbsDestinationVendorId = [];
      self.reTbsTransferJobNumber = [];
      self.reTbsProductGroupId = [];
      self.reTbsOccupiedDaysStart = null;
      self.reTbsOccupiedDaysEnd = null;
      //self.reTbsTransactionDateStart = null;
      //self.reTbsTransactionDateEnd = null;
      self.reTbsReturnTransactionDateStart = null;
      self.reTbsReturnTransactionDateEnd = null;

    // สร้างค่าเริ่มต้นย้อนหลัง 1 ปีจากวันนี้
    const today = moment();
    //const lastYear = moment().subtract(1, 'year'); // 🔹 ย้อน 1 ปี
    const lastYear = moment().startOf('year'); // ต้นปี

    // กำหนดค่า moment ให้ตัวแปรใน Vue (ถ้ามี)
    self.reTbsTransactionDateStart = lastYear;
    self.reTbsTransactionDateEnd = today;

          setTimeout(() => {
              //$(self.$refs.reTbsTransactionDateStart)
              //    .datepicker('setDate', lastYear.toDate())
              //    .trigger('changeDate');

              //$(self.$refs.reTbsTransactionDateEnd)
              //    .datepicker('setDate', today.toDate())
              //    .trigger('changeDate');

              //== แก้ปัญหา null ตอนโพสต์ ==
              $(self.$refs.reTbsTransactionDateStart)
                  .datepicker('setDate', lastYear.toDate());
              $(self.$refs.reTbsTransactionDateEnd)
                  .datepicker('setDate', today.toDate());

          }, 50); // ลองเริ่มที่ 50ms ถ้ายังไม่ขึ้น ลอง 100ms

    // 🔹 รอให้ Vue อัปเดต DOM เสร็จก่อน แล้วค่อย update datepicker
    //this.$nextTick(() => {
    //    $(self.$refs.reTbsTransactionDateStart)
    //        .datepicker('destroy')
    //        .datepicker({
    //            autoclose: true,
    //            clearBtn: true,
    //            format: "dd/mm/yyyy",
    //            orientation: "bottom left",
    //            todayBtn: "linked",
    //            todayHighlight: true,
    //            templates: arrows,
    //        })
    //        .datepicker('setDate', lastYear.toDate());

    //    $(self.$refs.reTbsTransactionDateEnd)
    //        .datepicker("setDate", today.toDate())
    //        .trigger('changeDate');
    //});

      $("#reTbsReturnStatus")
        .val("")
        .trigger("change");

      $("#reTbsBarcode")
        .val("")
        .trigger("change");

      $("#reTbsDepartmentMaterialCode")
        .val("")
        .trigger("change");

      $("#reTbsOriginPlantCode")
        .val("")
        .trigger("change");

      $("#reTbsProductTypeId")
        .val("")
        .trigger("change");

      $("#reTbsBrandId")
        .val("")
        .trigger("change");

      $("#reTbsSupplierSpareId")
        .val("")
        .trigger("change");

      $("#reTbsSpareUsedStatusId")
        .val("")
        .trigger("change");

      $("#reTbsAssetCode")
        .val("")
        .trigger("change");

      $("#reTbsReturnJobNumber")
        .val("")
        .trigger("change");

      $("#reTbsDestinationVendorId")
        .val("")
        .trigger("change");

      $("#reTbsTransferJobNumber")
        .val("")
        .trigger("change");

      $("#reTbsProductGroupId")
        .val("")
        .trigger("change");
    },
    isEmptyOrSpaces: function(str) {
      return str === null || str.match(/^ *$/) !== null;
    },
    formSubmit: function(e) {
      let self = this;

      e.preventDefault();
      var table = $("#brandCountTable").DataTable();
      table.draw();
    },
    exportBarcodes: function(e) {
      e.preventDefault();
      let self = this;

      if (
        self.reTbsOccupiedDaysStart !== null ||
        self.reTbsOccupiedDaysEnd !== null
      ) {
        if (
          self.reTbsOccupiedDaysStart === null &&
          self.reTbsOccupiedDaysEnd !== null
        ) {
          Swal.fire("กรุณาระบุ", "จำนวนวันคงค้าง(เริ่มต้น)", "warning");
          return false;
        } else if (
          self.reTbsOccupiedDaysStart !== null &&
          self.reTbsOccupiedDaysEnd === null
        ) {
          Swal.fire("กรุณาระบุ", "จำนวนวันคงค้าง(สิ้นสุด)", "warning");
          return false;
        }
      }

      if (self.reTbsTransactionDateStart !== null || self.reTbsTransactionDateEnd !== null)
      {
          if (self.reTbsTransactionDateStart === null && self.reTbsTransactionDateEnd !== null)
          {
              Swal.fire("กรุณาระบุ", "วันที่ส่งซ่อม(เริ่มต้น)", "warning");
              return false;
          }
          else if (self.reTbsTransactionDateStart !== null && self.reTbsTransactionDateEnd === null)
          {
              Swal.fire("กรุณาระบุ", "วันที่ส่งซ่อม(สิ้นสุด)", "warning");
              return false;
          }
      }

      if (
        self.reTbsReturnTransactionDateStart !== null ||
        self.reTbsReturnTransactionDateEnd !== null
      ) {
        if (
          self.reTbsReturnTransactionDateStart === null &&
          self.reTbsReturnTransactionDateEnd !== null
        ) {
          Swal.fire("กรุณาระบุ", "วันที่รับคืนจากการซ่อม(เริ่มต้น)", "warning");
          return false;
        } else if (
          self.reTbsReturnTransactionDateStart !== null &&
          self.reTbsReturnTransactionDateEnd === null
        ) {
          Swal.fire("กรุณาระบุ", "วันที่รับคืนจากการซ่อม(สิ้นสุด)", "warning");
          return false;
        }
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportTransferBarcodeSupplier",
        responseType: "arraybuffer",
        data: {
          OriginPlantCode: self.reTbsOriginPlantCode,
          DestinationVendorId: self.reTbsDestinationVendorId,
          TransferJobNumber: self.reTbsTransferJobNumber,
          ReturnJobNumber: self.reTbsReturnJobNumber,
          BarcodeNo: self.reTbsBarcode,
          DepartmentMaterialCode: self.reTbsDepartmentMaterialCode,
          ProductGroupId: self.reTbsProductGroupId,
          ProductTypeId: self.reTbsProductTypeId,
          AssetCode: self.reTbsAssetCode,
          BrandId: self.reTbsBrandId,
          SupplierSpareId: self.reTbsSupplierSpareId,
          SpareUsedStatusId: self.reTbsSpareUsedStatusId,
          OccupiedDaysStart: self.reTbsOccupiedDaysStart,
          OccupiedDaysEnd: self.reTbsOccupiedDaysEnd,
          TransactionDateStart:
            self.reTbsTransactionDateStart != null
              ? self.reTbsTransactionDateStart.format("DD/MM/YYYY")
              : null,
          TransactionDateEnd:
            self.reTbsTransactionDateEnd != null
              ? self.reTbsTransactionDateEnd.format("DD/MM/YYYY")
              : null,
          ReturnTransactionDateStart:
            self.reTbsReturnTransactionDateStart != null
              ? self.reTbsReturnTransactionDateStart.format("DD/MM/YYYY")
              : null,
          ReturnTransactionDateEnd:
            self.reTbsReturnTransactionDateEnd != null
              ? self.reTbsReturnTransactionDateEnd.format("DD/MM/YYYY")
              : null,
          ReturnStatus: self.reTbsReturnStatus,
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];
            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);

              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = decodeURIComponent(filename);
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    LoadreTbsDepartmentMaterialCodeOptions({ action, searchQuery, callback }) {
      var self = this;
      self.reTbsDepartmentMaterialCodeOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Barcode/Select2DepartmentMaterial", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reTbsDepartmentMaterialCodeOptions = [];
              data.forEach((element) => {
                self.reTbsDepartmentMaterialCodeOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.reTbsDepartmentMaterialCodeOptions);
          })
          .catch(function(error) {});
      }
    },
    LoadreTbsOriginPlantCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Plant/PlantOptions", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reTbsOriginPlantCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreTbsProductTypeIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductType/Select2ProductType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reTbsProductTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreTbsBrandIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reTbsBrandIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
      },
      LoadSupplierSpareOptions: function (e) {
          var self = this;
          axios
              .get("/Api/Product/Select2SearchSupplierSpareProduct", {
                  params: {
                      page: 1,
                      all: true,
                  },
              })
              .then(function (response) {
                  if (response.status == 200) {
                      var data = response.data.results;
                      data.forEach((element) => {
                          self.supplierSpareOptions.push({
                              id: element.id,
                              label: element.text,
                          });
                      });
                  }
              })
              .catch(function (error) { });
      },
      LoadSpareUsedStatusOptions: function (e) {
          var self = this;
          self.spareUsedStatusOptions.push(
              { id: 0, label: 'ยังไม่ระบุ' },
              { id: 1, label: 'ระบุเรียบร้อย' }
          );
      },

    LoadreTbsAssetCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reTbsAssetCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreTbsReturnJobNumberOptions({ action, searchQuery, callback }) {
      var self = this;
      self.reTbsReturnJobNumberOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Report/Select2ReturnJobNumber", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              data.forEach((element) => {
                self.reTbsReturnJobNumberOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.reTbsReturnJobNumberOptions);
          })
          .catch(function(error) {});
      }
    },
    LoadreTbsDestinationVendorIdOptions({ action, searchQuery, callback }) {
      var self = this;
      self.reTbsDestinationVendorIdOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Vendors/Select2Vendor", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reTbsDestinationVendorIdOptions = [];
              data.forEach((element) => {
                self.reTbsDestinationVendorIdOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.reTbsDestinationVendorIdOptions);
          });
      }
      },

      reLoadreTbsDestinationVendorIdOptions: function () {
          this.$refs.reTbsDestinationVendorId.trigger.searchQuery = null;
      },
    LoadreTbsTransferJobNumberOptions({ action, searchQuery, callback }) {
      var self = this;
      self.reTbsTransferJobNumberOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Report/Select2TransferJobNumber", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reTbsTransferJobNumberOptions = [];
              data.forEach((element) => {
                self.reTbsTransferJobNumberOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.reTbsTransferJobNumberOptions);
          });
      }
    },
    LoadreTbsProductGroupIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductGroup/Select2ProductGroup", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reTbsProductGroupIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    ClearAfterselect: function(){
      $(`[class="vue-treeselect__input"]`).val("");
    }
  },
  async mounted() {
    let self = this;

    self.LoadreTbsOriginPlantCodeOptions();
    self.LoadreTbsProductTypeIdOptions();
    self.LoadreTbsBrandIdOptions();
    self.LoadreTbsAssetCodeOptions();

    self.LoadreTbsProductGroupIdOptions();

      self.LoadSupplierSpareOptions();
      self.LoadSpareUsedStatusOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reBcDateReq = moment().format("DD/MM/YYYY h:mm a");

    //====== กำหนดค่าเริ่มต้น วันที่ส่งซ่อม =======
    // สร้างค่าเริ่มต้นย้อนหลัง 1 ปีจากวันนี้
    const today = moment();
    //const lastYear = moment().subtract(1, 'year'); // 🔹 ย้อน 1 ปี
    const lastYear = moment().startOf('year'); // ต้นปี

      // กำหนดค่า moment ให้ตัวแปรใน Vue (ถ้ามี)
    self.reTbsTransactionDateStart = lastYear;
    self.reTbsTransactionDateEnd = today;

    $(self.$refs.reTbsTransactionDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      //startDate: moment().subtract(2, "years").toDate(), // ตัวอย่าง: อนุญาตย้อนหลัง 2 ปี
      //endDate: moment().add(30, "days").toDate(),
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    // อัปเดตค่าตั้งต้นใน datepicker เป็นย้อนหลัง 1 ปี
    $(self.$refs.reTbsTransactionDateStart)
        .datepicker("update", lastYear.format("DD/MM/YYYY"))
        .on("changeDate", function (e) {
            if (e.dates && e.dates.length) {
                self.reTbsTransactionDateStart = moment(e.date);
            } else {
                self.reTbsTransactionDateStart = null;
            }
        });

    ////self.reApLastActivityDateEnd = moment().endOf('month');
    //$(self.$refs.reTbsTransactionDateStart)
    //  .datepicker(
    //    "update",
    //    !!self.reTbsTransactionDateStart
    //      ? self.reTbsTransactionDateStart.format("DD/MM/YYYY")
    //      : null
    //  )
    //  .on("changeDate", function(e) {
    //    self.reTbsTransactionDateStart =
    //      e.dates.length != 0 ? moment(e.date) : null;
    //  });

    $(self.$refs.reTbsTransactionDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      //rtl: KTUtil.isRTL(),
      //minDate: moment(), // Current day
      //maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });

    //self.reApLastActivityDateEnd = moment().endOf('month');
      $(self.$refs.reTbsTransactionDateEnd)
          .datepicker("update", today.format("DD/MM/YYYY"))
          .on("changeDate", function (e) {
              if (e.dates && e.dates.length) {
                  self.reTbsTransactionDateEnd = moment(e.date);
              } else {
                  self.reTbsTransactionDateEnd = null;
              }

              //self.reTbsTransactionDateEnd = e.dates.length
              //    ? moment(e.date)
              //    : null;
          });

    //=====
    $(self.$refs.reTbsReturnTransactionDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reApLastActivityDateEnd = moment().endOf('month');
    $(self.$refs.reTbsReturnTransactionDateStart)
      .datepicker(
        "update",
        !!self.reTbsReturnTransactionDateStart
          ? self.reTbsReturnTransactionDateStart.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.reTbsReturnTransactionDateStart =
          e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reTbsReturnTransactionDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reApLastActivityDateEnd = moment().endOf('month');
    $(self.$refs.reTbsReturnTransactionDateEnd)
      .datepicker(
        "update",
        !!self.reTbsReturnTransactionDateEnd
          ? self.reTbsReturnTransactionDateEnd.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.reTbsReturnTransactionDateEnd =
          e.dates.length != 0 ? moment(e.date) : null;
      });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/TransferBarcodeSupplier.vue